import React from 'react';

/*
  LogoutSuccess — post-logout confirmation page extracted from App.js.
  Props: navigateTo
*/
const LogoutSuccess = ({ navigateTo }) => {
  const btnPrimary = {
    background: 'var(--accent)',
    color: 'white', border: 'none', borderRadius: '9px', fontWeight: 700,
    cursor: 'pointer', transition: 'all 0.2s ease',
    boxShadow: '0 0 24px rgba(139,92,246,0.35)', fontFamily: 'inherit',
  };
  const btnPrimaryHover = (e) => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = '0 0 40px rgba(139,92,246,0.6)';
  };
  const btnPrimaryLeave = (e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 0 24px rgba(139,92,246,0.35)';
  };

  return (
        <section style={{ minHeight: '100vh', backgroundColor: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center', padding: '0 24px' }}>
            <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 28px', boxShadow: '0 0 32px rgba(139,92,246,0.45)' }}>
              <svg width="32" height="28" viewBox="0 0 32 28" fill="none"><path d="M2 14L11 23L30 2" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </div>
            <h1 style={{ fontSize: '30px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '12px', letterSpacing: '-0.02em' }}>Successfully Logged Out</h1>
            <p style={{ fontSize: '16px', color: 'var(--text-secondary)', marginBottom: '40px' }}>Thank you for using Axigon AI</p>
            <button onClick={() => navigateTo('company')} style={{ ...btnPrimary, padding: '14px 36px', fontSize: '15px' }} onMouseEnter={btnPrimaryHover} onMouseLeave={btnPrimaryLeave}>
              Return to Home
            </button>
          </div>
        </section>
  );
};

export default LogoutSuccess;
